// SZ: estado reativo compartilhado dos contadores da sidebar.
// Evita registrar Vuex module (mexer em store/index.js) — usa ref ES module
// que é única por bundle: ambos Sidebar.vue e ChatList.vue (banner) leem
// o mesmo objeto, sem refetch duplicado.
import { ref } from 'vue';

export const szSidebarCounts = ref({ inboxes: {}, labels: {}, teams: {} });

let _fetching = false;
export async function fetchSzSidebarCounts(accountId) {
  if (!accountId || _fetching) return;
  _fetching = true;
  try {
    // eslint-disable-next-line no-undef
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId}/conversations/sz_sidebar_counts`
    );
    szSidebarCounts.value = {
      inboxes: data?.inboxes || {},
      labels: data?.labels || {},
      teams: data?.teams || {},
    };
  } catch {
    // silent
  } finally {
    _fetching = false;
  }
}
